import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorMessage, InternalDocumentTypesEnum } from '@sparling/financial-common'

export const uploadKycFileResolver = yupResolver(
  yup.object().shape({
    docType: yup
      .mixed<InternalDocumentTypesEnum>()
      .oneOf(Object.values(InternalDocumentTypesEnum), errorMessage.INVALID_ENUM_VALUE)
      .required(errorMessage.EMPTY_FIELD),

    comment: yup.string().required(errorMessage.EMPTY_FIELD).max(255, errorMessage.MAX_255_CHARACTERS),

    file: yup.mixed<File>().required(errorMessage.EMPTY_FIELD),
  }),
)
